import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

// This function creates a set of function that helps us create multipart component styles.
const helpers = createMultiStyleConfigHelpers([]);

const Filters = helpers.defineMultiStyleConfig({
  baseStyle: {
    CreateBundleFilters: {
      display: 'flex',
      gap: '16px',
      margin: '0 auto',
      isolation: 'isolate',
      maxWidth: 'fit-content',
      alignItems: 'baseline',
      position: 'relative',
      zIndex: '20',
    },
  },
  sizes: {},
  variants: {},
  defaultProps: {},
});

export default Filters;
